export default {
	appEnv: "production",
	apiUrl: "https://api.getvirtualbrain.com",
	contentApiUrl: "https://content-api.getvirtualbrain.com",
	chatbotApiUrl: "https://chatbot-api.getvirtualbrain.com",
};
